import { EditableProTable } from '@ant-design/pro-components';
import { Modal, Button, message, Input } from 'antd';
import { nanoid } from 'nanoid';
import React, { useEffect, useRef, useState } from 'react';
import { updateDB, cursorGetDataToList, deleteDB } from './indexedDB.js'

const checkCordsData = (latStr, lonStr) => {
	const lat = parseFloat(latStr);
	const lon = parseFloat(lonStr);
	if (lat && lon && lat <= 90 && lat >= -90 && lon <= 180 && lon >= -180) {
		return [true, lat, lon]
	} else {
		message.warning(`输入的坐标值不正确`)
		return [false, lat, lon]
	}
}

const LocBaseModal = (props) => {
	const { db, showing, setShowing } = props;
	const [keyword, setKeyword] = useState('');
	const [filter, setFilter] = useState('');
	const [cordsList, setCordsList] = useState([]);
	const [dataSource, setDataSource] = useState([]);
	const actionRef = useRef();

	useEffect(() => {
		if (showing) {
			setKeyword("");
			setFilter('');
			if (db) {
				cursorGetDataToList(db, "Cords", setCordsList)
			}
		}
	}, [showing])

	const columns = [
		{
			title: '地名',
			dataIndex: 'loc',
			width: '30%',
			formItemProps: (form, { rowIndex }) => {
				return {
					rules: rowIndex > 1 ? [{ required: true, message: '此项为必填项' }] : [],
				};
			},
		},
		{
			title: '经度',
			dataIndex: 'lon',
			width: '25%',
		},
		{
			title: '纬度',
			dataIndex: 'lat',
			width: '25%',
		},
		{
			title: '操作',
			valueType: 'option',
			width: '15%',
			render: (text, record, _, action) => [
				(record.editable === undefined || record.editable) ? <a key="editable" onClick={() => {
					var _a;
					(_a = action === null || action === void 0 ? void 0 : action.startEditable) === null || _a === void 0 ? void 0 : _a.call(action, record.id);
				}}>编辑
				</a> : '',
				(record.deletable === undefined || record.deletable) ? <a key="delete" onClick={() => {
					setCordsList(cordsList.filter(item => item.id !== record.id));
					deleteDB(db, "Cords", record.loc)
				}}>删除
				</a> : '',
			],
		},
	]

	const handleFilter = (e) => {
		e.preventDefault()
		const { keyCode, target } = e
		setKeyword(target.value)
		if (keyCode !== 13) {
			return
		} else {
			setFilter(target.value)
			target.value = ''
		}
	}

	useEffect(() => {
		setDataSource(cordsList.filter(item => item.loc.includes(filter)));
	}, [filter, cordsList])


	return (
		<Modal open={props.showing} width={'80%'} onCancel={() => { setShowing(prev => !prev) }}
			title="地名库管理（可在地图上点右键新增地名）" maskClosable={false} footer={[]}>
			<Input placeholder="请输入筛选条件……" type="text" value={keyword} onChange={e => setKeyword(e.target.value)} onKeyUp={handleFilter} />
			<EditableProTable rowKey="id" size='small' scroll={{ y: '50dvh' }} actionRef={actionRef}
				recordCreatorProps={{
					newRecordType: 'dataSource',
					position: 'top',
					creatorButtonText: '新增地名',
					record: () => {
						return { id: nanoid(), }
					},
				}} loading={false} columns={columns} value={dataSource} onChange={setDataSource}
				editable={{
					type: 'multiple',
					onSave: (rowKey, data, row) => {
						const [ok, lat, lon] = checkCordsData(data.lat, data.lon)
						if (db && ok) {
							updateDB(db, "Cords", { loc: data.loc, lat: lat, lon: lon })
							setCordsList(cordsList.map(item => {
								if (item.id === rowKey) {
									return { id: rowKey, loc: data.loc, lat: lat, lon: lon }
								} else {
									return item
								}
							}))
						}
					},
				}}
			/>
		</Modal>
	)
}

export default LocBaseModal;